module.exports = __webpack_public_path__ + "static/media/Brios-Frutal-Descripcion-Mobile.688739a4.webp";